import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'
export default new Vuex.Store({
  strict: debug,
  state:{
    staff:{},
    tabs:[],
    clickTab:'',
    staMy:false,
    stores:{productName:'',storeId:''},
    orderMsgStatus:''
  },
  mutations:{
    clearTabs(state){
      state.tabs=[];
    },
    updateStaff(state,staff){
      state.staff=staff;
    },
    setOrderMsgStatus(state,orderMsgStatus){
      state.orderMsgStatus=orderMsgStatus;
    },
    setStores(state, stores){
      state.stores= stores;
    },
    setStaMy(state,staMy){
      state.staMy=staMy
    },
    addTab(state,tab){
      var i=state.tabs.findIndex(item=>item.name==tab.name);
      if(i==-1){
        state.tabs.push(tab);
      }else{
        for(let i=0;i<state.tabs.length;i++){
          if(tab.name==state.tabs[i].name){
            state.tabs.splice(i,1,tab);
            break;
          }
        }
      }
    },
    closeTab(state,name){
      if(name=='新增用户订单'){
        state.userOrderValid=1;
      }
      var i=state.tabs.findIndex(item=>item.name==name);
      state.tabs.splice(i,1);
    },
    setterClickTab(state,value){
      state.clickTab = value;
    },
  },
  getters:{
    tabs:state=>{
      return state.tabs;
    },
    staff:state=>{
      return state.staff;
    },
    getStaMy:state=>{
      return state.staMy;
    },
    permissions:state=>{
      return state.staff.permissions;
    },
    hasPermission:(state)=>(permission)=>{
      return state.staff.permissions.findIndex(item=>item===permission)>=0?true:false;
    },
    mobilePermissions:state=>{
      return state.staff.mobilePermissions;
    },
    hasMobilePermission:(state)=>(mobilePermissions)=>{
      return state.staff.mobilePermissions.findIndex(item=>item===mobilePermissions)>=0?true:false;
    },
    getTabs:state=>{
      return state.clickTab;
    },
    getStores:state=>{
      return state.stores;
    },
    getOrderMsgStatus:state=>{
      return state.orderMsgStatus;
    }
  },
  actions:{

  }
})



// WEBPACK FOOTER //
// ./src/store/store.js